import { createAction, props } from '@ngrx/store';
import { IUserSession } from 'src/app/core/dto';

export const USER_AUTHED_SUCCESSFULLY = '[USER_AUTHED_SUCCESSFULLY]';
export const LOGOUT = '[LOGOUT]';
export const USER_PREFERENCES_UPDATED = '[USER_PREFERENCES_UPDATED]';

export const logoutAction = createAction(LOGOUT);

export const userAuthedSuccessfully = createAction(
  USER_AUTHED_SUCCESSFULLY,
  props<{ payload: IUserSession }>()
);

/**
 * Patch the current user's session with new language/units overrides.
 * Used after a self-save so the active session reflects the new value
 * immediately — no page reload or session re-fetch needed.
 */
export const userPreferencesUpdated = createAction(
  USER_PREFERENCES_UPDATED,
  props<{ userLanguage?: string; userInchesUnit?: string }>()
);
